import { ticoticketApi } from "../ticoticketApi";

interface registerNormalUserParams extends loginUserParams {
  name: string;
}

interface loginUserParams {
  email: string;
  password: string;
}
export const registerNormalUser = async ({
  email,
  password,
  name,
}: registerNormalUserParams) => {
  try {
    // Haces la llamada POST a tu API para registrar al usuario
    const { data } = await ticoticketApi.post("/auth/register", {
      email,
      password,
      name,
    });
    // Suponiendo que tu API responde con { ok: true, user: userData } cuando es exitoso
    return { ok: true, user: data.user, token: data.token };
  } catch (error: any) {
    // Aquí capturas el error y retornas un objeto indicando el fallo
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};

export const loginUser = async ({ email, password }: loginUserParams) => {
  try {
    // Haces la llamada POST a tu API para iniciar sesión
    const { data } = await ticoticketApi.post("/auth/login", {
      email,
      password,
    });
    // Suponiendo que tu API responde con { ok: true, user: userData } cuando es exitoso
    console.log(data);

    return { ok: true, user: data.user, token: data.token };
  } catch (error: any) {
    // Aquí capturas el error y retornas un objeto indicando el fallo
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};

export const getRoles = async (token: string) => {
  try {
    // Haces la llamada POST a tu API para iniciar sesión
    const { data } = await ticoticketApi.get("/auth/check-roles", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { ok: true, roles: data };
  } catch (error: any) {
    // Aquí capturas el error y retornas un objeto indicando el fallo
    console.log(error.response.data);
    return {
      ok: false,
      errorMessage: error.response.data,
    };
  }
};
